(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marame-collection"] && !Shopify.designMode) return;
  try {
    
function marameHasNativeCollectionQuery(href) {
  if (marameColourSalesQueryUrl(href)) return false;
  return [...new URL(href).searchParams.keys()].some(key => key === 'sort_by' || key.startsWith('filter.'));
}
function marameColourSalesQueryUrl(href) {
  const url=new URL(href),sort=url.searchParams.getAll('sort_by');
  if(sort.length!==1||sort[0]!=='best-selling'||[...url.searchParams.keys()].some(key=>key.startsWith('filter.'))) return null;
  url.searchParams.delete('sort_by');url.searchParams.set('marame_sort','best-selling');
  if(url.searchParams.has('page')) {
    const page=Number(url.searchParams.get('page'));
    if(Number.isSafeInteger(page)&&page>1&&!url.searchParams.has('marame_page')) url.searchParams.set('marame_page',String(page));
    url.searchParams.delete('page');
  }
  return url;
}
function marameCollectionResetUrl(collectionUrl, href) {
  const current = new URL(href);
  const reset = new URL(collectionUrl, current.origin);
  const previewTheme = current.searchParams.get('preview_theme_id');
  if (previewTheme) reset.searchParams.set('preview_theme_id', previewTheme);
  return reset;
}
function marameReadFilterState(href) {
  const p=(marameColourSalesQueryUrl(href)||new URL(href)).searchParams;
  const price=key=>{const value=p.get(key);return value!==null&&value!==''&&Number.isFinite(Number(value))&&Number(value)>=0?Math.round(Number(value)*100):'';};
  return {colours:[...new Set(p.getAll('marame_colour').filter(Boolean))],sizes:[...new Set(p.getAll('marame_size').filter(Boolean))],available:p.get('marame_available')==='1',sort:p.get('marame_sort')||'curated',minPrice:price('marame_min'),maxPrice:price('marame_max'),page:Number(p.get('marame_page'))||1};
}
function marameFilterStateUrl(state,href) {
  const url=marameColourSalesQueryUrl(href)||new URL(href);
  for(const name of ['marame_colour','marame_size','marame_available','marame_sort','marame_min','marame_max','marame_page'])url.searchParams.delete(name);
  for(const value of state.colours||[])url.searchParams.append('marame_colour',value);
  for(const value of state.sizes||[])url.searchParams.append('marame_size',value);
  if(state.available)url.searchParams.set('marame_available','1');
  if(state.sort&&state.sort!=='curated')url.searchParams.set('marame_sort',state.sort);
  if(state.minPrice!==''&&state.minPrice!=null)url.searchParams.set('marame_min',String(state.minPrice/100));
  if(state.maxPrice!==''&&state.maxPrice!=null)url.searchParams.set('marame_max',String(state.maxPrice/100));
  if(state.page>1)url.searchParams.set('marame_page',String(state.page));
  return url;
}
function marameCategoryStateUrl(category,state,href) {
  const destination=marameCollectionResetUrl(category,href);
  return marameFilterStateUrl({...state,page:1},destination.href);
}
function marameRemoveFilter(state,type,value) {
  const next={...state,page:1};
  if(type==='all')Object.assign(next,{colours:[],sizes:[],available:false,sort:'curated',minPrice:'',maxPrice:''});
  else if(['colours','sizes'].includes(type)){
    next[type]=(state[type]||[]).filter(item=>item!==value);
    if(type==='sizes'&&!next.sizes.length)next.available=false;
  }else if(type==='price'){next.minPrice='';next.maxPrice='';}
  else if(type==='sort')next.sort='curated';else next.available=false;
  return next;
}
// Family tokens are separate from exact shade values so old bookmarked shade URLs stay exact.
const MARAME_COLOUR_FAMILIES = {
  black:['Black','#1a1a1a'], white:['White','#f5f5f5'], cream:['Cream','#f0ebe0'],
  beige:['Beige','#d8cdb8'], brown:['Brown','#7a4f35'], grey:['Grey','#9a9690'],
  blue:['Blue','#4a6a9a'], green:['Green','#6a8c6a'], pink:['Pink','#d4929a'],
  red:['Red','#b94040'], orange:['Orange','#c87840'], yellow:['Yellow','#ddc564'],
  purple:['Purple','#a898c0'], metallic:['Metallic','#b9b6af'], clear:['Clear','#f7f7f7'],
  multicolour:['Multicolour','#c0bdb8'], other:['Other','#c0bdb8']
};
function marameColourFamilyOverrides(text) {
  const overrides=new Map();
  if(typeof text!=='string'||text.length>64000)return overrides;
  for(const line of text.split(/\r?\n/).slice(0,500)) {
    const divider=line.lastIndexOf('=');if(divider<1)continue;
    const shade=line.slice(0,divider).trim().toLowerCase(),family=line.slice(divider+1).trim().toLowerCase();
    if(shade&&Object.hasOwn(MARAME_COLOUR_FAMILIES,family))overrides.set(shade,family);
  }
  return overrides;
}
function marameColourFamily(shade,overrides=new Map()) {
  if(typeof shade!=='string'||!shade.trim())return null;
  const value=shade.trim().toLowerCase();
  if(overrides.has(value))return overrides.get(value);
  const named={
    'almond taupe':'beige','beige taupe':'beige','light taupe':'beige','putty dove':'beige',
    'butterscotch':'brown','canyon clay':'brown','caramel':'brown','cinnamon sugar':'brown',
    'clay':'brown','honey havana':'brown','honeyburst':'brown','old brown havana':'brown',
    'pacific teak':'brown','true demi':'brown','wholemeal':'beige',
    'crystal peach':'pink','fiery rose':'pink','molten rouge':'red','morning meadow':'green',
    'pure glass':'clear','silver ice':'grey','terracotta':'orange','citrus':'yellow','olive tortoise':'green',
    'classic wash denim':'blue','light wash denim':'blue','pure denim':'blue'
  };
  if(named[value])return named[value];
  if(/[\/&+]/.test(value)||/\b(and|multi|multicolou?r)\b/.test(value))return 'multicolour';
  const rules=[
    ['black',/\bblack\b/],['cream',/\b(cream|ivory|ecru|vanilla)\b/],['white',/\bwhite\b/],
    ['blue',/\b(blue|navy|denim|cobalt|indigo)\b/],['brown',/\b(brown|chocolate|tan|camel|toffee|copper|tortoise|tortoiseshell)\b/],
    ['beige',/\b(beige|sand|sandstone|stone|taupe|natural)\b/],['grey',/\b(grey|gray|charcoal|slate)\b/],
    ['green',/\b(green|khaki|olive|sage|meadow)\b/],['pink',/\b(pink|rose|blush|peach)\b/],
    ['red',/\b(red|burgundy|rouge|wine)\b/],['orange',/\b(orange|rust|terracotta)\b/],
    ['yellow',/\b(yellow|lemon|citrus|mustard)\b/],['purple',/\b(purple|violet|lilac|mauve)\b/],
    ['metallic',/\b(gold|silver|metallic|bronze)\b/],['clear',/\b(clear|transparent|glass)\b/]
  ];
  return rules.find(([,pattern])=>pattern.test(value))?.[0]||'other';
}
function marameColourFamilyToken(value) {
  if(typeof value!=='string'||!value.startsWith('family:'))return null;
  const family=value.slice(7);return Object.hasOwn(MARAME_COLOUR_FAMILIES,family)?family:null;
}
function marameColourFilterLabel(value,labels={}) {
  const family=marameColourFamilyToken(value);
  if(family)return labels[family]||MARAME_COLOUR_FAMILIES[family][0];
  return (labels.exactShade||'[shade] (exact shade)').replace('[shade]',value);
}
function marameColourFilterChoices(cards,selected=[],labels={}) {
  return [...new Set([...cards.map(card=>card.family?'family:'+card.family:null),...selected].filter(Boolean))]
    .sort((a,b)=>marameColourFilterLabel(a,labels).localeCompare(marameColourFilterLabel(b,labels)));
}
function selectMarameColourCards(cards, state) {
  const seen = new Set();
  const matches = [];
  const pageSize = Math.max(1, Math.min(48, Math.floor(Number(state.pageSize) || 24)));
  for (const card of cards) {
    if (seen.has(card.key)) continue;
    seen.add(card.key);
    const colours = Array.isArray(state.colours) ? state.colours : state.colour ? [state.colour] : [];
    const sizes = Array.isArray(state.sizes) ? state.sizes : state.size ? [state.size] : [];
    if (colours.length && !colours.some(value=>{const family=marameColourFamilyToken(value);return family ? card.family===family : card.colour===value;})) continue;
    const min = state.minPrice === '' || state.minPrice == null ? null : Number(state.minPrice);
    const max = state.maxPrice === '' || state.maxPrice == null ? null : Number(state.maxPrice);
    const variants = card.variants.filter(v => (!sizes.length || sizes.includes(v.size)) && (!state.available || (v.available === true && v.comingSoon !== true)) && v.matched !== false && (min == null || v.price >= min) && (max == null || v.price <= max));
    if (!variants.length) continue;
    matches.push({ card, variants, price: Math.min(...variants.map(v => v.price)) });
  }
  matches.sort((a,b) => {
    const price = state.sort === 'price-asc' ? a.price-b.price : state.sort === 'price-desc' ? b.price-a.price : 0;
    return price || a.card.rank-b.card.rank || (a.card.key < b.card.key ? -1 : a.card.key > b.card.key ? 1 : 0);
  });
  const pages = Math.ceil(matches.length/pageSize);
  const page = Math.min(Math.max(1, Math.floor(Number(state.page) || 1)), Math.max(1,pages));
  return { matches, pageCards:matches.slice((page-1)*pageSize,page*pageSize), page, pages, total:matches.length };
}
function marameImportedColourOrder(data) {
  const imported = data.merchandising?.imported;
  if (!imported || !Array.isArray(imported.ids) || imported.ids.length > 500) return {ids:[], hidden:[], keys:[], hiddenKeys:[]};
  const ids = imported.ids.filter(id => /^\d+$/.test(String(id))).map(String);
  const hidden = Array.isArray(imported.hidden) && imported.hidden.length <= 500 ? imported.hidden.map(String) : [];
  const colourKeys = values => Array.isArray(values) && values.length <= 500 ? values.filter(value => {
    try { const pair=JSON.parse(value);return Array.isArray(pair)&&pair.length===2&&/^\d+$/.test(pair[0])&&(typeof pair[1]==='string'||pair[1]===null); } catch { return false; }
  }) : [];
  return {ids, hidden, keys:colourKeys(imported.keys), hiddenKeys:colourKeys(imported.hiddenKeys)};
}
function marameStockPriority(card) {
  const variants = card.variants || [];
  const ready = variants.filter(v => v.available === true && v.comingSoon !== true && v.preorder !== true);
  const stocked = ready.filter(v => Number.isFinite(v.stock) && v.stock > 0);
  if (stocked.length && ready.every(v => Number.isFinite(v.stock))) return [0, -stocked.reduce((sum,v) => sum + v.stock, 0)];
  if (ready.some(v => v.stock == null)) return [1, 0];
  if (variants.some(v => v.available === true && v.comingSoon !== true)) return [2, 0];
  return [3, 0];
}
function resolveMarameColourRanks(data) {
  const mode = data.merchandising?.mode;
  const imported = marameImportedColourOrder(data);
  if (mode === 'shopify') return {ids:[], source:mode, issues:[]};
  if (mode && mode !== 'manual') return {ids:imported.ids, keys:imported.keys, source:imported.ids.length ? 'live-import' : 'default', issues:[]};
  if (mode === 'manual') {
    const manual = resolveMarameColourRanks({...data, merchandising:null, rankVariantIds:[]});
    return manual.ids.length ? manual : {ids:imported.ids, keys:imported.keys, source:imported.ids.length ? 'live-import' : 'default', issues:[...manual.issues,'manual-menu-empty']};
  }
  const legacy = Array.isArray(data.rankVariantIds) ? data.rankVariantIds : [];
  // Existing explicit metafield ordering has priority; a new menu never silently replaces it.
  if (legacy.length) return { ids:legacy, source:'metafield', issues:data.orderMenu ? ['menu-overridden-by-metafield'] : [] };
  const menu = data.orderMenu;
  if (!menu) return { ids:[], source:'default', issues:[] };
  const groups = menu.groups;
  if (menu.valid !== true || !Array.isArray(groups) || groups.length > 500 || menu.nodeCount > 500 || groups.some(group => !Array.isArray(group) || group.length > 500)) {
    return { ids:[], source:'default', issues:['menu-structure'] };
  }
  const urls = groups.flat();
  if (urls.length > 500 || new TextEncoder().encode(JSON.stringify(groups)).byteLength > 64000) return { ids:[], source:'default', issues:['menu-budget'] };
  const known = new Set(data.products.flatMap(product => product.variants.map(variant => String(variant.id))));
  const hosts = new Set((menu.allowedHosts || []).filter(Boolean).map(host => String(host).toLowerCase()));
  const ids = [], seen = new Set(), issues = [];
  for (const href of urls) {
    try {
      if (typeof href !== 'string' || href.length > 500) throw new Error('invalid');
      const url = new URL(href, 'https://marame-relative.invalid');
      const relative = href.startsWith('/') && !href.startsWith('//');
      if (!['https:','http:'].includes(url.protocol) || url.username || url.password || (!relative && !hosts.has(url.hostname.toLowerCase())) || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('invalid');
      const values = url.searchParams.getAll('variant');
      if (values.length !== 1 || !/^\d+$/.test(values[0])) throw new Error('invalid');
      const id = values[0];
      if (!known.has(id)) { issues.push('stale-variant'); continue; }
      if (seen.has(id)) { issues.push('duplicate-variant'); continue; }
      seen.add(id); ids.push(id);
    } catch(error) { issues.push('invalid-link'); }
  }
  return { ids, source:ids.length ? 'menu' : 'default', issues };
}
function buildMarameColourCards(data) {
  const cards = [];
  const colourOverrides=marameColourFamilyOverrides(data.colourFamilyOverrides);
  const ranks = new Map();
  const resolvedOrder = resolveMarameColourRanks(data);
  for (const id of resolvedOrder.ids) if (!ranks.has(String(id))) ranks.set(String(id),ranks.size);
  const colourRanks = new Map((resolvedOrder.keys || []).map((key,index)=>[key,index]));
  const rankOffset = Math.max(ranks.size,colourRanks.size);
  // Imported exclusions only control whether a colour tile is displayed. They
  // never alter native variant availability, purchase options or the catalogue.
  const hidden = new Set(data.merchandising?.preserveHidden === true ? marameImportedColourOrder(data).hidden : []);
  const hiddenKeys = new Set(data.merchandising?.preserveHidden === true ? marameImportedColourOrder(data).hiddenKeys : []);
  for (const product of data.products) {
    const grouped = new Map();
    for (const variant of product.variants) {
      const key = JSON.stringify([product.id,variant.colour]);
      let card = grouped.get(key);
      if (!card) {
        const gallery = (product.galleries || []).find(item=>item.colour===variant.colour);
        card = { key, productId:product.id, sizeContext:product.sizeContext, title:product.title, badges:product.badges || {}, url:product.url, image:null, fallbackImage:variant.colour ? gallery?.image : product.image, galleryCount:gallery?.count || 0, swatches:product.swatches || [], colour:variant.colour, family:marameColourFamily(variant.colour,colourOverrides), rank:rankOffset+cards.length, variants:[] };
        grouped.set(key,card); cards.push(card);
        if (colourRanks.has(key)) card.rank=colourRanks.get(key);
      }
      if (!card.image && variant.image) card.image = variant.image;
      if (ranks.has(String(variant.id))) card.rank = Math.min(card.rank,ranks.get(String(variant.id)));
      card.variants.push(variant);
    }
  }
  const visible = cards.filter(card => !hiddenKeys.has(card.key) && !card.variants.some(variant => hidden.has(String(variant.id))));
  if (data.merchandising?.mode === 'stock') {
    visible.sort((a,b) => {
      const x=marameStockPriority(a), y=marameStockPriority(b);
      return x[0]-y[0] || x[1]-y[1] || a.rank-b.rank;
    });
    visible.forEach((card,index) => card.rank=index);
  }
  return visible;
}
// Ordinal ranks are generated from complete, reconciled Shopify variant net sales.
// All sizes of one colour share one rank. Equal sales retain the curated tie order.
function marameApplySalesRanks(cards,snapshot) {
  if(snapshot?.schemaVersion!==1||snapshot.metric!=='net_items_sold'||snapshot.complete!==true||
     !Number.isFinite(Date.parse(snapshot.generatedAt))||!/^\d{4}-\d{2}-\d{2}$/.test(snapshot.since||'')||
     !/^\d{4}-\d{2}-\d{2}$/.test(snapshot.until||'')||snapshot.since>snapshot.until||
     !Array.isArray(snapshot.groups)||!snapshot.groups.length||snapshot.groups.length>5000) throw new Error('Colour sales ranking unavailable');
  const byVariant=new Map();
  snapshot.groups.forEach((group,index)=>{
    if(!Array.isArray(group)||group.length!==3||!/^[1-9]\d*$/.test(group[0])||!Array.isArray(group[1])||
       !group[1].length||group[1].length>250||!Number.isSafeInteger(group[2])||group[2]<0) throw new Error('Invalid colour sales group');
    for(const id of group[1]){
      if(typeof id!=='string'||!/^[1-9]\d*$/.test(id)||byVariant.has(id)) throw new Error('Duplicate or invalid sales variant');
      byVariant.set(id,{productId:group[0],rank:group[2],group:index});
    }
  });
  if(byVariant.size>25000) throw new Error('Colour sales ranking budget');
  const assigned=new Map();
  const ranked=cards.map(card=>{
    const matches=card.variants.map(variant=>byVariant.get(String(variant.id))).filter(Boolean);
    if(matches.some(match=>match.productId!==String(card.productId)||match.group!==matches[0].group)) throw new Error('Colour sales identity changed');
    const match=matches[0];
    if(match){
      if(assigned.has(match.group)&&assigned.get(match.group)!==card.key) throw new Error('Colour sales grouping changed');
      assigned.set(match.group,card.key);
    }
    return {card,salesRank:match?.rank??Infinity};
  });
  ranked.sort((a,b)=>a.salesRank-b.salesRank||a.card.rank-b.card.rank||a.card.key.localeCompare(b.card.key));
  return ranked.map(({card},rank)=>({...card,rank}));
}
function marameColourCardPrice(variants, price) {
  const money=variants.find(variant=>variant.price===price) || variants[0];
  const range=variants.some(variant=>variant.price!==price);
  const compare=!range && money?.compareAt>price && variants.every(variant=>variant.compareAt===money.compareAt) ? money.compareAtText : null;
  return {money,range,compare};
}
function marameColourCardBadge(card, variants, settings = {}, labels = {}) {
  if (!Array.isArray(variants) || !variants.length) return null;
  const purchasable = variants.filter(variant => variant.available === true && variant.comingSoon !== true);
  const choice = purchasable[0] || variants.find(variant => variant.comingSoon === true) || variants[0];
  const badge = (kind, text) => typeof text === 'string' && text.trim() ? { kind, text: text.trim().slice(0, 40) } : null;
  if (choice.comingSoon === true) return badge('coming-soon', labels.comingSoon);
  if (!purchasable.length) return badge('sold-out', labels.soldOut);
  if (choice.preorder === true) return badge('preorder', labels.preorder);
  if (settings.enabled !== true) return null;
  if (typeof card.badges?.custom === 'string' && card.badges.custom.trim()) return badge('custom', card.badges.custom);
  if (card.badges?.new === true) return badge('new', labels.badgeNew);
  if (settings.sale === true && variants.every(variant => Number.isFinite(variant.price) && Number.isFinite(variant.compareAt) && variant.compareAt > variant.price)) return badge('sale', labels.badgeSale);
  const colourVariants = card.variants || [];
  const stockKnown = colourVariants.length > 0 && colourVariants.every(variant => Number.isFinite(variant.stock) && variant.continueSelling === false && variant.comingSoon !== true && variant.preorder !== true);
  const totalStock = stockKnown ? colourVariants.reduce((sum, variant) => sum + Math.max(0, variant.stock), 0) : null;
  const threshold = Number(settings.threshold);
  if (settings.lowStock === true && Number.isInteger(threshold) && threshold >= 1 && threshold <= 20 && totalStock > 0 && totalStock <= threshold) return badge('low-stock', labels.badgeLowStock);
  return null;
}
function marameCollectionSwatch(value, swatches=[]) {
  const native=swatches.find(s=>s.name===value);
  const colours={white:'#f5f5f5',ivory:'#f5f1e8',sky:'#a8c4d4',red:'#b94040',ecru:'#e8e0cc',natural:'#d4c4a8',tan:'#c8996e',melange:'#b0aaaa',navy:'#2a3550',slate:'#7a8898',chocolate:'#5c3a1e',cream:'#f0ebe0',rust:'#b5572a',taupe:'#b5a898',brown:'#7a4f35',sand:'#d4b896',sage:'#8a9e88',cobalt:'#2a4a8a',black:'#1a1a1a',olive:'#5c6240',stone:'#c4bfb4',grey:'#9a9690',gray:'#9a9690',green:'#6a8c6a',blue:'#4a6a9a',pink:'#d4929a',lilac:'#a898c0',burgundy:'#7a2a38',camel:'#c8a060',beige:'#d8cdb8',khaki:'#8a8660',mauve:'#b08898','light wash':'#a8bcd4','dark wash':'#4a5870',tortoiseshell:'#7a4f1a',crystal:'#d8d0c0',copper:'#c07840'};
  return {colour:native?.colour||colours[String(value).toLowerCase()]||'#c0bdb8',image:native?.image||null};
}
function marameTogglePriceBand(state, min, max) {
  const lower=min===''?'':Number(min),upper=max===''?'':Number(max);
  return state.minPrice===lower&&state.maxPrice===upper?{minPrice:'',maxPrice:''}:{minPrice:lower,maxPrice:upper};
}
function marameGridColumns(value) {
  return ['3','4','5'].includes(String(value)) ? String(value) : '4';
}
function marameCollectionImageSizes(columns) {
  const width=(100/Number(marameGridColumns(columns))).toFixed(4).replace(/0+$/, '').replace(/\.$/, '');
  return `(min-width: 1024px) ${width}vw, (min-width: 430px) 215px, 50vw`;
}
function marameCollectionPageNumbers(page,pages) {
  if(pages<=5)return Array.from({length:pages},(_,index)=>index+1);
  if(page<=3)return [1,2,3,null,pages];
  if(page>=pages-2)return [1,null,pages-2,pages-1,pages];
  return [1,null,page,null,pages];
}
if (!customElements.get('marame-collection-snap')) customElements.define('marame-collection-snap', class extends HTMLElement {
  connectedCallback() {
    this.collection = this.closest('marame-collection');
    this.grid = this.collection?.querySelector('[data-grid]');
    this.sticky = this.collection?.querySelector('.marame-collection__sticky');
    this.enhanced = this.collection?.querySelector('[data-enhanced]');
    if (!this.grid || !this.sticky || !window.ResizeObserver || !window.IntersectionObserver || !CSS.supports('scroll-snap-type', 'y proximity')) return;
    this.events = new AbortController();
    const signal = this.events.signal;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.motion.addEventListener('change', () => this.reset(), {signal});
    this.viewportWidth = innerWidth;
    this.gridWidth = this.grid.clientWidth;
    this.resize = new ResizeObserver(() => this.layoutChanged());
    for (const element of [this.grid, this.sticky, document.querySelector('.section-header')].filter(Boolean)) this.resize.observe(element);
    this.gridChanges = new MutationObserver(() => { this.reset(); this.watchEnd(); });
    this.gridChanges.observe(this.grid, {childList: true});
    this.visibility = new MutationObserver(() => this.reset());
    this.visibility.observe(this.enhanced, {attributes: true, attributeFilter: ['hidden']});
    this.visibility.observe(document.body, {attributes: true, attributeFilter: ['class', 'style']});
    for (const dialog of document.querySelectorAll('dialog')) this.visibility.observe(dialog, {attributes: true, attributeFilter: ['open']});
    this.boundaries = new IntersectionObserver(() => this.schedule(), {threshold: [0, 1], rootMargin: '0px 0px 24px 0px'});
    this.ends = [...this.collection.querySelectorAll('[data-pagination]'), ...document.querySelectorAll('footer')];
    this.ends.forEach(element => this.boundaries.observe(element));
    this.watchEnd();
    window.addEventListener('wheel', event => this.intent(event), {passive: true, signal});
    window.addEventListener('touchstart', event => { this.touch = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null; }, {passive: true, signal});
    window.addEventListener('touchmove', event => this.intent(event), {passive: true, signal});
    window.addEventListener('keydown', event => this.intent(event), {signal});
    window.addEventListener('resize', () => this.layoutChanged(), {passive: true, signal});
    window.addEventListener('pagehide', () => this.reset(), {signal});
    window.addEventListener('pageshow', () => this.reset(), {signal});
    window.addEventListener('popstate', () => this.reset(), {signal});
    this.collection.addEventListener('click', event => { if (event.target.closest('[data-grid-columns], [data-pagination], [data-filter-open], [data-remove-filter]')) this.reset(); }, {capture: true, signal});
    this.reset();
  }
  watchEnd() {
    if (this.lastCard) this.boundaries?.unobserve(this.lastCard);
    this.lastCard = this.grid.lastElementChild;
    if (this.lastCard) this.boundaries?.observe(this.lastCard);
  }
  intent(event) {
    if (!event.isTrusted || event.defaultPrevented || event.ctrlKey || event.metaKey || document.readyState === 'loading') return;
    if (event.target.closest('input, textarea, select, button, [contenteditable="true"], dialog[open], .marame-categories, .marame-collection__chips')) return;
    if (event.type === 'wheel' && Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
    if (event.type === 'touchmove') {
      if (!this.touch || event.touches.length !== 1) return;
      const dx = Math.abs(event.touches[0].clientX - this.touch.x), dy = Math.abs(event.touches[0].clientY - this.touch.y);
      if (dy < 8 || dy <= dx) return;
    }
    if (event.type === 'keydown' && !['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', ' '].includes(event.key)) return;
    if (this.armed && this.hasAttribute('data-active')) return;
    const firstIntent = !this.armed;
    this.armed = true;
    if (firstIntent) this.measure();
    else this.schedule();
  }
  layoutChanged() {
    const viewportWidth = innerWidth, gridWidth = this.grid.clientWidth;
    const widthChanged = viewportWidth !== this.viewportWidth || gridWidth !== this.gridWidth;
    this.viewportWidth = viewportWidth;
    this.gridWidth = gridWidth;
    if (widthChanged) this.reset();
    else this.schedule();
  }
  reset() {
    this.armed = false;
    this.disable();
    this.schedule();
  }
  schedule() {
    if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.measure(); });
  }
  disable() {
    this.removeAttribute('data-active');
    this.collection?.removeAttribute('data-row-snap-active');
    for (const card of this.marked || []) card.removeAttribute('data-row-snap');
    this.marked = [];
  }
  measure() {
    this.disable();
    if (!this.armed || this.motion.matches || this.enhanced.hidden || document.querySelector('dialog[open]')) return;
    if (['hidden', 'clip'].includes(getComputedStyle(document.body).overflowY) || ['hidden', 'clip'].includes(getComputedStyle(document.documentElement).overflowY)) return;
    const cards = [...this.grid.children].filter(card => card.offsetHeight > 0);
    if (!cards.length) return;
    const last = cards[cards.length - 1].getBoundingClientRect();
    if (last.bottom <= innerHeight + 24 || this.grid.getBoundingClientRect().top >= innerHeight) return;
    if (this.ends.some(element => { const r = element.getBoundingClientRect(); return r.height > 0 && r.top < innerHeight + 24 && r.bottom > 0; })) return;
    const offset = Math.max(0, parseFloat(getComputedStyle(this.sticky).top) || 0) + this.sticky.offsetHeight + 8;
    const available = innerHeight - offset - 16;
    const rows = [];
    for (const card of cards) {
      let row = rows[rows.length - 1];
      if (!row || Math.abs(row.top - card.offsetTop) > 2) { row = {top: card.offsetTop, height: 0, first: card}; rows.push(row); }
      row.height = Math.max(row.height, card.offsetHeight);
    }
    if (rows.length < 2 || rows.some(row => row.height > available)) return;
    this.collection.style.setProperty('--marame-row-snap-offset', `${Math.ceil(offset)}px`);
    this.marked = rows.slice(1).map(row => row.first);
    this.marked.forEach(card => card.setAttribute('data-row-snap', ''));
    this.collection.setAttribute('data-row-snap-active', '');
    this.setAttribute('data-active', '');
  }
  disconnectedCallback() {
    this.events?.abort();
    this.resize?.disconnect();
    this.gridChanges?.disconnect();
    this.visibility?.disconnect();
    this.boundaries?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    this.disable();
    this.collection?.style.removeProperty('--marame-row-snap-offset');
  }
});

if (!customElements.get('marame-collection')) customElements.define('marame-collection', class extends HTMLElement {
  connectedCallback() {
    // A legacy native page number would make Liquid's full-index pagination
    // empty. Normalize that bookmark once; first-page links need no reload.
    const salesUrl=marameColourSalesQueryUrl(location.href);
    if(salesUrl&&new URL(location.href).searchParams.has('page')) {location.replace(salesUrl.href);return;}
    this.setupGridView();
    const categoryScroll=this.querySelector('[data-category-scroll]');
    if(categoryScroll&&!categoryScroll.dataset.ready){categoryScroll.hidden=false;categoryScroll.dataset.ready='true';categoryScroll.addEventListener('click',()=>this.querySelector('.marame-categories').scrollBy({left:120,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));}
    for (const link of this.querySelectorAll('[data-clear]')) link.href = marameCollectionResetUrl(link.getAttribute('href'), location.href).href;
    const nativeQuery = marameHasNativeCollectionQuery(location.href);
    this.querySelector('[data-native-clear]').hidden = !nativeQuery;
    if (nativeQuery) return;
    if (this.initialised) { window.addEventListener('popstate',this.popListener); return; }
    const source = this.querySelector('[data-collection-index]');
    if (!source) return;
    try {
      if (new TextEncoder().encode(source.textContent).byteLength > 2000000) return;
      this.data = JSON.parse(source.textContent);
      this.cards = buildMarameColourCards(this.data);
      const orderNote = this.querySelector('[data-order-menu-note]');
      if (orderNote) orderNote.hidden = resolveMarameColourRanks(this.data).issues.length === 0;
      this.form = this.querySelector('[data-filters]');
      this.grid = this.querySelector('[data-grid]');
      this.initialised = true;
      this.pools = new Map();
      if (this.data.merchandising?.mode !== 'best-selling') {
        this.pools.set(new URL(this.dataset.collectionUrl,location.origin).pathname+'|curated',this.cards);
      }
      this.pendingPools = new Map();
      this.loadVersion=0;this.previewVersion=0;
      const category=this.form.elements.category;
      const links=[...this.querySelectorAll('[data-category-link]'),{href:this.dataset.collectionUrl,textContent:this.querySelector('h1').textContent}];
      const knownCategories=new Set();
      for(const link of links){const url=new URL(link.href,location.origin);if(url.origin!==location.origin||knownCategories.has(url.pathname))continue;knownCategories.add(url.pathname);const option=document.createElement('option');option.value=url.pathname;option.textContent=link.textContent;category.append(option);}
      this.knownCategories=knownCategories;
      this.allCategory=new URL(this.querySelector('[data-category-all]')?.href||this.dataset.collectionUrl,location.origin).pathname;
      this.querySelectorAll('[data-category-link]').forEach(link=>link.dataset.categoryPath=new URL(link.href,location.origin).pathname);
      this.querySelector('[data-category-control]').hidden=category.options.length<2;
      for(const option of category.options){const button=document.createElement('button');button.type='button';button.dataset.filterSelect='category';button.dataset.value=option.value;button.textContent=option.textContent;button.setAttribute('aria-pressed','false');this.querySelector('[data-category-buttons]').append(button);}
      this.querySelector('[data-filter-retry]').addEventListener('click',()=>this.previewFilters());
      this.querySelector('[data-filter-update-retry]').addEventListener('click',async()=>{if(await this.update(this.pendingState||this.readState(),this.pendingPush===true))this.querySelector('h1')?.focus({preventScroll:true});});
      this.colours = marameColourFilterChoices(this.cards,[],this.data.colourFamilyLabels);
      this.sizes = [...new Set(this.cards.flatMap(c=>c.variants.map(v=>v.size)).filter(Boolean))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
      this.dialog = this.querySelector('[data-filter-dialog]');
      this.trigger = this.querySelector('[data-filter-open]');
      if(typeof IntersectionObserver!=='undefined'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){this.revealObserver=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting){entry.target.classList.add('is-visible');this.revealObserver.unobserve(entry.target);}},{rootMargin:'0px 0px -30px 0px'});}
      for (const [name,values] of [['colours',this.colours],['sizes',this.sizes]]) {
        const holder=this.form.querySelector(`[data-filter-values="${name}"]`);
        for (const value of values) {
          holder.append(this.filterChoice(name,value,this.cards,{}));
        }
        holder.closest('fieldset').hidden=values.length===0;
      }
      this.popListener = () => {this.closeFilters(false);this.update(this.readState(),false);};
      this.trigger.addEventListener('click',()=>this.openFilters());
      this.form.addEventListener('input',event=>this.onFilterInput(event));
      this.form.addEventListener('change',event=>this.onFilterInput(event));
      this.form.addEventListener('click',event=>{
        const select=event.target.closest('[data-filter-select]'),band=event.target.closest('[data-price-band]');
        if(select){const field=this.form.elements[select.dataset.filterSelect];field.value=select.dataset.filterSelect==='category'&&field.value===select.dataset.value?this.allCategory:select.dataset.value;this.previewFilters();}
        if(band){const state=marameTogglePriceBand(this.formState(),band.dataset.min,band.dataset.max);this.form.elements.min_price.value=state.minPrice===''?'':state.minPrice/100;this.form.elements.max_price.value=state.maxPrice===''?'':state.maxPrice/100;this.previewFilters();}
      });
      this.form.addEventListener('submit',event=>{event.preventDefault();this.applyFilters();});
      this.querySelector('[data-filter-close]').addEventListener('click',()=>this.closeFilters());
      this.querySelector('[data-filter-reset]').addEventListener('click',()=>{this.setForm({category:this.allCategory,colours:[],sizes:[],available:false,sort:'curated',minPrice:'',maxPrice:''});this.previewFilters();});
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.closeFilters();});
      this.dialog.addEventListener('pointerdown',event=>{this.backdropDown=event.target===this.dialog;});
      this.dialog.addEventListener('click',event=>{if(this.backdropDown&&event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.closeFilters();}this.backdropDown=false;});
      this.querySelector('[data-filter-chips]').addEventListener('click',event=>{
        const button=event.target.closest('[data-remove-filter]');if(!button)return;
        if(button.tagName==='A')return;
        const state=marameRemoveFilter(this.state,button.dataset.removeFilter,button.dataset.value);
        this.update(state,true);this.trigger.focus({preventScroll:true});
      });
      this.querySelector('[data-pagination]').addEventListener('click',event=>this.changePage(event));
      window.addEventListener('popstate',this.popListener);
      this.update(this.readState(),false);

      this.querySelector('[data-enhanced]').hidden = false;
      this.trigger.hidden=false;
      this.querySelector('[data-native]').hidden = true;
    } catch(error) { this.initialised=false; }
  }
  disconnectedCallback() { this.gridEvents?.abort();this.loadVersion++;this.revealObserver?.disconnect();if(this.popListener) window.removeEventListener('popstate',this.popListener);this.closeFilters(false); }
  setupGridView() {
    this.gridEvents?.abort();
    const controls=this.querySelector('[data-grid-view]');
    if(!controls)return;
    let columns=this.dataset.gridColumns;
    try { columns=sessionStorage.getItem('marame:collection-columns')||columns; } catch {}
    this.setGridColumns(columns);
    controls.hidden=false;
    this.gridEvents=new AbortController();
    controls.addEventListener('click',event=>{
      const button=event.target.closest('[data-grid-columns]');
      if(button&&controls.contains(button))this.setGridColumns(button.dataset.gridColumns,true);
    },{signal:this.gridEvents.signal});
  }
  setGridColumns(value,persist=false) {
    const columns=marameGridColumns(value);
    this.dataset.gridColumns=columns;
    const sizes=marameCollectionImageSizes(columns);
    for(const image of this.querySelectorAll('[data-grid] img, [data-native]:not([hidden]) img'))image.sizes=sizes;
    for(const button of this.querySelectorAll('[data-grid-view] [data-grid-columns]'))button.setAttribute('aria-pressed',String(button.dataset.gridColumns===columns));
    if(persist){try { sessionStorage.setItem('marame:collection-columns',columns); } catch {}}
  }
  readState() {
    return marameReadFilterState(location.href);
  }
  stateUrl(state) {
    return marameFilterStateUrl(state,location.href);
  }
  normalState(state) {
    const colours=Array.isArray(state.colours)?state.colours:state.colour?[state.colour]:[];
    const sizes=Array.isArray(state.sizes)?state.sizes:state.size?[state.size]:[];
    return {...state,colours:[...new Set(colours)],sizes:[...new Set(sizes)],sort:['curated','best-selling','price-asc','price-desc'].includes(state.sort)?state.sort:'curated'};
  }
  formState() {
    const value=name=>this.form.elements[name].value;
    return {category:value('category'),colours:[...this.form.querySelectorAll('[name="colours"]:checked')].map(el=>el.value),sizes:[...this.form.querySelectorAll('[name="sizes"]:checked')].map(el=>el.value),available:this.form.elements.available.checked,sort:value('sort'),minPrice:value('min_price')===''?'':Math.round(Number(value('min_price'))*100),maxPrice:value('max_price')===''?'':Math.round(Number(value('max_price'))*100),page:1};
  }
  onFilterInput(event) {
    if(event.target.name==='sizes')this.form.elements.available.checked=this.form.querySelectorAll('[name="sizes"]:checked').length>0;
    this.previewFilters();
  }
  setForm(state) {
    this.form.elements.category.value=state.category||new URL(this.dataset.collectionUrl,location.origin).pathname;
    this.form.querySelectorAll('[name="colours"],[name="sizes"]').forEach(el=>el.checked=(state[el.name]||[]).includes(el.value));
    this.form.elements.available.checked=Boolean(state.available);this.form.elements.sort.value=state.sort||'curated';
    this.form.elements.min_price.value=state.minPrice==null||state.minPrice===''?'':state.minPrice/100;
    this.form.elements.max_price.value=state.maxPrice==null||state.maxPrice===''?'':state.maxPrice/100;
    this.syncFilterButtons();
  }
  syncFilterButtons() {
    const state=this.formState();
    const legacy=state.sizes.length>0&&!state.available;
    this.form.querySelector('[data-filter-size-help]').hidden=legacy;
    this.form.querySelector('[data-filter-size-legacy]').hidden=!legacy;
    this.form.querySelectorAll('[data-filter-select]').forEach(button=>button.setAttribute('aria-pressed',String(this.form.elements[button.dataset.filterSelect].value===button.dataset.value)));
    this.form.querySelectorAll('[data-price-band]').forEach(button=>button.setAttribute('aria-pressed',String((button.dataset.min===''?'':Number(button.dataset.min))===state.minPrice&&(button.dataset.max===''?'':Number(button.dataset.max))===state.maxPrice)));
    this.querySelector('[data-filter-reset]').hidden=!state.colours.length&&!state.sizes.length&&!state.available&&state.sort==='curated'&&state.minPrice===''&&state.maxPrice===''&&state.category===this.allCategory;
  }
  sizeFilterLabel(value,cards=this.activeCards||this.cards) {
    if(this.sizeLabelHelper)return this.sizeLabelHelper(value,cards,this.dataset.shoppingCountry,this.sizeDisplayHelper,this.sizeRegionBundle);
    const symbol=String(value).match(/\((XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL)\)$/i);
    return symbol?symbol[1].toUpperCase():value;
  }
  loadFilterSizeLabels() {
    if(this.sizeLabelRequest)return this.sizeLabelRequest;
    if(!this.dataset.sizeLabelsUrl||!this.dataset.sizeDisplayUrl)return Promise.resolve();
    this.sizeLabelRequest=Promise.all([import(this.dataset.sizeLabelsUrl),import(this.dataset.sizeDisplayUrl)]).then(async([labels,helper])=>{
      const bundle=await helper.loadSizeRegions(this.dataset.sizeRegionsUrl);
      if(!this.isConnected)return;
      this.sizeLabelHelper=labels.filterSizeLabel;this.sizeDisplayHelper=helper;this.sizeRegionBundle=bundle;
      for(const input of this.form.querySelectorAll('[name="sizes"]')){
        const text=input.closest('label')?.querySelector('.marame-filter-choice__label');
        if(text)text.textContent=this.sizeFilterLabel(input.value,this.choiceCards||this.cards);
      }
      if(this.state)this.renderChips();
    }).catch(()=>{this.sizeLabelRequest=null;});
    return this.sizeLabelRequest;
  }
  filterChoice(name,value,cards,state) {
    const label=document.createElement('label');label.className='marame-filter-choice'+(name==='colours'?' marame-filter-choice--colour':'');
    const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;input.checked=(state[name]||[]).includes(value);label.append(input);
    if(name==='colours'){const family=marameColourFamilyToken(value),swatch=family?{colour:MARAME_COLOUR_FAMILIES[family][1]}:marameCollectionSwatch(value,cards.flatMap(card=>card.swatches||[])),dot=document.createElement('span');dot.className='marame-filter-swatch';dot.setAttribute('aria-hidden','true');dot.style.backgroundColor=swatch.colour;if(family==='multicolour')dot.style.backgroundImage='conic-gradient(#b94040,#ddc564,#6a8c6a,#4a6a9a,#a898c0,#b94040)';else if(swatch.image)dot.style.backgroundImage=`url("${swatch.image.replace(/"/g,'%22')}")`;label.append(dot);}
    const text=document.createElement('span');text.className='marame-filter-choice__label';text.textContent=name==='colours'?marameColourFilterLabel(value,this.data?.colourFamilyLabels):this.sizeFilterLabel(value,cards);label.append(text);return label;
  }
  validPrices(state) {
    return [state.minPrice,state.maxPrice].every(v=>v===''||(Number.isFinite(v)&&v>=0))&&(state.minPrice===''||state.maxPrice===''||state.minPrice<=state.maxPrice);
  }
  async loadSalesRanks() {
    if(this.salesRanks) return this.salesRanks;
    if(!this.pendingSalesRanks) this.pendingSalesRanks=(async()=>{
      if(!this.dataset.salesRanksUrl) throw new Error('Colour sales ranking unavailable');
      const response=await fetch(this.dataset.salesRanksUrl,{credentials:'omit',headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error('Colour sales ranking unavailable');
      const text=await response.text();
      if(new TextEncoder().encode(text).byteLength>500000) throw new Error('Colour sales ranking budget');
      const snapshot=JSON.parse(text);
      marameApplySalesRanks([],snapshot);
      this.salesRanks=snapshot;return snapshot;
    })();
    try {return await this.pendingSalesRanks;} finally {this.pendingSalesRanks=null;}
  }
  async loadPool(category,sort) {
    const path=category||new URL(this.dataset.collectionUrl,location.origin).pathname;
    if(!this.knownCategories.has(path))throw new Error('Unknown category');
    const ordering=sort==='best-selling'?'best-selling':'curated';
    const key=path+'|'+ordering;
    if(this.pools.has(key))return this.pools.get(key);
    if(this.pendingPools.has(key))return this.pendingPools.get(key);
    const promise=(async()=>{
      const url=marameCollectionResetUrl(path,location.href);
      const currentPath=new URL(this.dataset.collectionUrl,location.origin).pathname;
      // Use this template instance for its saved settings. Another category may
      // have a different template, so read its own full page index instead.
      if(path===currentPath && this.dataset.sectionId)url.searchParams.set('section_id',this.dataset.sectionId);
      // Explicit preview links are retained by resetUrl; ordinary published
      // pages must not acquire a preview cookie merely by changing a filter.
      if(/^\d+$/.test(this.dataset.previewThemeId||''))url.searchParams.set('preview_theme_id',this.dataset.previewThemeId);
      const readIndex = async () => {
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Collection response');
        const html=await response.text();if(new TextEncoder().encode(html).byteLength>3000000)throw new Error('Collection budget');
        const source=new DOMParser().parseFromString(html,'text/html').querySelector('[data-collection-index]');
        if(!source||new TextEncoder().encode(source.textContent).byteLength>2000000)throw new Error('Collection index unavailable');
        const data=JSON.parse(source.textContent);
        if(this.dataset.themeId && String(data.themeId)!==this.dataset.themeId)throw new Error('Collection theme changed');
        if(!Array.isArray(data.products)||data.products.length>250||data.products.some(p=>!Array.isArray(p.variants)||p.variants.length>250))throw new Error('Invalid collection');
        return data;
      };
      let data=await readIndex();
      const useSales=ordering==='best-selling'||data.merchandising?.mode==='best-selling';
      if(useSales) data={...data,merchandising:{...(data.merchandising||{}),mode:'best-selling'}};
      let cards=buildMarameColourCards(data);
      if(useSales) cards=marameApplySalesRanks(cards,await this.loadSalesRanks());
      this.pools.set(key,cards);return cards;
    })();
    this.pendingPools.set(key,promise);
    try{return await promise;}finally{this.pendingPools.delete(key);}
  }
  renderFilterChoices(cards,state) {
    this.choiceCards=cards;
    for(const name of ['colours','sizes']) {
      const values=name==='colours'?marameColourFilterChoices(cards,state.colours||[],this.data?.colourFamilyLabels):[...new Set([...cards.flatMap(c=>c.variants.map(v=>v.size)),...(state.sizes||[])].filter(Boolean))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
      const holder=this.form.querySelector(`[data-filter-values="${name}"]`);holder.replaceChildren();
      for(const value of values)holder.append(this.filterChoice(name,value,cards,state));
      holder.closest('fieldset').hidden=values.length===0;
    }
    this.choiceCategory=state.category||new URL(this.dataset.collectionUrl,location.origin).pathname;
  }
  async previewFilters() {
    const version=++this.previewVersion;
    const state=this.formState(),valid=this.validPrices(state);
    this.syncFilterButtons();
    this.querySelector('[data-filter-price-error]').hidden=valid;
    this.querySelector('[data-filter-load-error]').hidden=true;
    const apply=this.querySelector('[data-filter-apply]');apply.disabled=true;
    if(!valid)return;
    apply.textContent=this.form.dataset.loadingLabel;
    try {
      const cards=await this.loadPool(state.category,state.sort);
      if(version!==this.previewVersion)return;
      if(this.choiceCategory!==state.category)this.renderFilterChoices(cards,state);
      const count=selectMarameColourCards(cards,{...state,pageSize:this.data.pageSize}).total;
      apply.textContent=(count===1?this.form.dataset.applyOneLabel:this.form.dataset.applyLabel).replace('[count]',String(count));apply.disabled=false;
    } catch(error) {if(version===this.previewVersion)this.querySelector('[data-filter-load-error]').hidden=false;}
  }
  async applyFilters() {
    const draft=this.formState();if(!this.validPrices(draft))return;
    const applyVersion=this.applyVersion=(this.applyVersion||0)+1;
    const currentPath=new URL(this.dataset.collectionUrl,location.origin).pathname;
    if(draft.category!==currentPath){
      const button=this.querySelector('[data-filter-apply]');button.disabled=true;
      try{await this.loadPool(draft.category,draft.sort);if(applyVersion!==this.applyVersion||!this.dialog.open||!this.isConnected)return;location.assign(marameCategoryStateUrl(draft.category,draft,location.href).href);}
      catch(error){if(applyVersion===this.applyVersion&&this.dialog.open){this.querySelector('[data-filter-load-error]').hidden=false;button.disabled=false;}}
      return;
    }
    if(await this.update({...draft,page:1},true))this.closeFilters();
  }
  openFilters() {
    if(!this.state)return;
    this.loadFilterSizeLabels();
    this.renderFilterChoices(this.cards,this.state);this.setForm(this.state);this.previewFilters();
    this.ownsFilterLock=!document.body.classList.contains('overflow-hidden');document.body.classList.add('overflow-hidden');
    this.dialog.showModal();this.trigger.setAttribute('aria-expanded','true');
  }
  closeFilters(focus=true) {
    this.previewVersion++;
    this.applyVersion=(this.applyVersion||0)+1;
    if(!this.dialog?.open)return;this.dialog.close();this.trigger.setAttribute('aria-expanded','false');
    if(this.ownsFilterLock)document.body.classList.remove('overflow-hidden');this.ownsFilterLock=false;
    if(focus&&this.trigger.isConnected)this.trigger.focus({preventScroll:true});
  }
  renderChips() {
    const list=this.querySelector('[data-filter-chips]');list.replaceChildren();
    const currentPath=new URL(this.dataset.collectionUrl,location.origin).pathname;
    const hasCategory=currentPath!==this.allCategory;
    const add=(type,value,label,href)=>{const button=document.createElement(href?'a':'button');if(href)button.href=href;else button.type='button';button.dataset.removeFilter=type;button.dataset.value=value;button.textContent=label+' ×';button.setAttribute('aria-label',type==='all'?this.form.dataset.clearLabel:this.form.dataset.removeLabel.replace('[filter]',label));list.append(button);};
    if(hasCategory){const categoryLabel=[...this.form.elements.category.options].find(option=>option.value===currentPath)?.textContent||this.querySelector('h1').textContent;add('category','',categoryLabel,marameCategoryStateUrl(this.allCategory,this.state,location.href).href);}
    this.state.colours.forEach(value=>add('colours',value,marameColourFilterLabel(value,this.data?.colourFamilyLabels)));this.state.sizes.forEach(value=>add('sizes',value,(this.state.available?this.form.dataset.availableSizeLabel:this.form.dataset.sizeLabel)+': '+this.sizeFilterLabel(value)));
    if(this.state.available&&!this.state.sizes.length)add('available','',this.form.dataset.availableLabel);
    if(this.state.minPrice!==''&&this.state.minPrice!=null||this.state.maxPrice!==''&&this.state.maxPrice!=null){const band=[...this.form.querySelectorAll('[data-price-band]')].find(button=>(button.dataset.min===''?'':Number(button.dataset.min))===this.state.minPrice&&(button.dataset.max===''?'':Number(button.dataset.max))===this.state.maxPrice);add('price','',band?.textContent.trim()||this.form.dataset.priceLabel);}
    if(this.state.sort!=='curated')add('sort','',this.form.elements.sort.selectedOptions[0]?.textContent||this.form.dataset.sortLabel);
    const count=list.children.length;
    const countLabel=this.querySelector('[data-filter-count]');countLabel.hidden=count===0;countLabel.textContent='('+count+')';
    this.trigger.classList.toggle('has-filters',count>0);
    if(count)add('all','',this.form.dataset.clearLabel,hasCategory?marameCollectionResetUrl(this.allCategory,location.href).href:null);list.hidden=count===0;
    for(const link of this.querySelectorAll('[data-category-link]')){const target=link.dataset.categoryPath===currentPath?this.allCategory:link.dataset.categoryPath;link.href=marameCategoryStateUrl(target,this.state,location.href).href;}
  }
  async update(state,push) {
    const version=++this.loadVersion;state=this.normalState(state);this.pendingState=state;this.pendingPush=push;
    let cards;
    try{cards=await this.loadPool(new URL(this.dataset.collectionUrl,location.origin).pathname,state.sort);}
    catch(error){if(version===this.loadVersion)this.querySelector('[data-filter-status]').hidden=false;return false;}
    if(version!==this.loadVersion||!this.isConnected)return false;
    this.querySelector('[data-filter-status]').hidden=true;
    const result=selectMarameColourCards(cards,{...state,pageSize:this.data.pageSize});
    this.state={...state,page:result.page};
    this.activeCards=cards;
    if(this.state.sizes.length)this.loadFilterSizeLabels();
    if(push) history.pushState({},'',this.stateUrl(this.state));
    this.setForm(this.state);this.renderChips();
    const fragment=document.createDocumentFragment();
    result.pageCards.forEach((item,index)=>{const card=this.cardElement(item,index);if(this.revealObserver&&index>=5){card.dataset.reveal='';card.style.setProperty('--tile-delay',`${(index%2)*.06}s`);}fragment.append(card);});
    this.grid.replaceChildren(fragment);
    this.revealObserver?.disconnect();this.grid.querySelectorAll('[data-reveal]').forEach(card=>this.revealObserver?.observe(card));
    this.grid.classList.toggle('marame-collection__grid--few',result.total<3);
    const countLabel=result.total===1?(this.data.labels.countOne||this.data.labels.count):this.data.labels.count;
    this.querySelector('[data-count]').textContent=countLabel.replace('[count]',String(result.total));
    this.querySelector('[data-empty]').hidden=result.total!==0;
    this.renderPagination(result);
    return true;
  }
  renderPagination(result) {
    const nav=this.querySelector('[data-pagination]');
    nav.hidden=result.pages<2;
    this.querySelector('[data-page]').textContent=this.data.labels.page.replace('[page]',String(result.page)).replace('[pages]',String(result.pages));
    for(const [selector,page,disabled] of [['[data-previous]',result.page-1,result.page<=1],['[data-next]',result.page+1,result.page>=result.pages]]) {
      const link=this.querySelector(selector);link.hidden=false;
      if(disabled){link.setAttribute('aria-disabled','true');link.removeAttribute('href');delete link.dataset.targetPage;}
      else{link.removeAttribute('aria-disabled');link.dataset.targetPage=String(page);link.href=this.stateUrl({...this.state,page}).href;}
    }
    const numbers=this.querySelector('[data-page-numbers]');numbers.replaceChildren();
    for(const page of marameCollectionPageNumbers(result.page,result.pages)) {
      const item=document.createElement(page===null?'span':'a');
      item.textContent=page===null?'…':String(page);
      if(page===null){item.className='marame-pagination__gap';item.setAttribute('aria-hidden','true');}
      else {
        item.setAttribute('aria-label',nav.dataset.pageLabel.replace('[number]',String(page)));
        item.href=this.stateUrl({...this.state,page}).href;
        if(page===result.page)item.setAttribute('aria-current','page');
        else item.dataset.targetPage=String(page);
      }
      numbers.append(item);
    }
  }
  async changePage(event) {
    const link=event.target.closest('a[data-target-page]');
    if(!link||event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const page=Number(link.dataset.targetPage);
    if(!Number.isInteger(page)||page<1||page===this.state?.page)return;
    event.preventDefault();
    // Keep the current page and scroll position if loading fails or a newer
    // filter/page request wins. Only deliberate successful navigation moves focus.
    if(await this.update({...this.state,page},true)) {
      this.querySelector('h1')?.focus({preventScroll:true});
      this.scrollIntoView({block:'start',behavior:'instant'});
    }
  }
  cardElement({card,variants,price},index) {
    const purchasable=variants.filter(v=>v.available === true && v.comingSoon !== true);
    const choice=purchasable[0] || variants.find(v=>v.comingSoon === true) || variants[0];
    const pricing=marameColourCardPrice(variants,price);
    const money=pricing.money;
    const article=document.createElement('article'); article.className='marame-colour-card';
    const link=document.createElement('a'); link.className='marame-colour-card__link';
    const target=new URL(card.url,location.origin); target.searchParams.set('variant',choice.id); link.href=target.href;
    const media=document.createElement('marame-card-gallery'); media.className='marame-colour-card__media';
    Object.assign(media.dataset,{productUrl:target.href,productId:String(card.productId),variantId:String(choice.id),colour:card.colour||'',count:String(card.galleryCount),previousLabel:this.dataset.galleryPrevious,nextLabel:this.dataset.galleryNext,counterLabel:this.dataset.galleryCounter,errorLabel:this.dataset.galleryError});
    media.setAttribute('role','group');media.setAttribute('aria-label',card.colour?`${card.title}, ${card.colour}`:card.title);
    const track=document.createElement('div');track.className='marame-card-gallery__track';
    const imageLink=document.createElement('a');imageLink.className='marame-card-gallery__slide';imageLink.href=target.href;
    const source=choice.image || card.image || card.fallbackImage;
    if(source) {
      const img=document.createElement('img'); const imageUrl=new URL(source,location.origin);
      img.sizes=marameCollectionImageSizes(this.dataset.gridColumns);
      img.alt=card.colour?`${card.title} — ${card.colour}`:card.title;
      img.width=900;img.height=1200;img.loading=index<2?'eager':'lazy';img.decoding='async';if(index===0)img.fetchPriority='high';img.draggable=false;
      img.srcset=[300,450,600,900].map(width=>{const u=new URL(imageUrl);u.searchParams.set('width',String(width));return `${u.href} ${width}w`;}).join(', ');
      img.src=imageUrl.href;
      imageLink.append(img);
    }
    track.append(imageLink);media.append(track);
    const details=document.createElement('div');details.className='marame-colour-card__details';
    const heading=document.createElement('h2');heading.textContent=card.title;details.append(heading);
    if(card.colour){const colour=document.createElement('span');colour.className='marame-colour-card__colour';colour.textContent=card.colour;details.append(colour);}
    const bottom=document.createElement('div');bottom.className='marame-colour-card__bottom';
    const swatches=document.createElement('span');swatches.className='marame-colour-card__swatches';swatches.setAttribute('aria-hidden','true');
    for(const value of card.swatches.length>1?card.swatches:[]){const swatch=marameCollectionSwatch(value.name,card.swatches),dot=document.createElement('span');dot.title=value.name;dot.style.backgroundColor=swatch.colour;if(swatch.image)dot.style.backgroundImage=`url("${swatch.image.replace(/"/g,'%22')}")`;swatches.append(dot);}bottom.append(swatches);
    const priceRow=document.createElement('span');priceRow.className='marame-colour-card__price';
    if(pricing.compare){priceRow.classList.add('marame-colour-card__price--sale');const previous=document.createElement('del');previous.textContent=pricing.compare;previous.setAttribute('aria-label',`${this.dataset.regularPrice}: ${pricing.compare}`);priceRow.append(previous);}
    const amount=document.createElement('span');amount.textContent=pricing.range?this.data.labels.fromPrice.replace('[price]',money.priceText):money.priceText;if(pricing.compare)amount.setAttribute('aria-label',`${this.dataset.salePrice}: ${money.priceText}`);priceRow.append(amount);bottom.append(priceRow);details.append(bottom);
    const badge=marameColourCardBadge(card,variants,this.data.badgeSettings,this.data.labels);
    if(badge){const action=document.createElement('span');action.className='marame-colour-card__action';action.dataset.badgeKind=badge.kind;action.textContent=badge.text;article.append(action);}
    link.append(details);article.append(media,link);
    const wishlist=document.createElement('marame-wishlist-action');
    Object.assign(wishlist.dataset,{context:'card',productId:String(card.productId),variantId:String(choice.id),productTitle:card.title,variantTitle:card.colour||''});
    article.append(wishlist);
    if(this.dataset.quickAddEnabled === 'true') {
      const quickAdd=document.createElement('a'); quickAdd.className='marame-colour-card__quick-add'; quickAdd.href=target.href;
      quickAdd.setAttribute('data-marame-quick-add',''); quickAdd.setAttribute('aria-haspopup','dialog');
      quickAdd.setAttribute('aria-label',`${this.dataset.quickAddLabel}: ${card.title}${card.colour ? `, ${card.colour}` : ''}`);
      const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');icon.setAttribute('width','10');icon.setAttribute('height','10');icon.setAttribute('viewBox','0 0 10 10');icon.setAttribute('aria-hidden','true');const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M5 1v8M1 5h8');path.setAttribute('stroke','currentColor');path.setAttribute('stroke-width','1');path.setAttribute('stroke-linecap','round');icon.append(path);quickAdd.append(icon);article.append(quickAdd);
    }
    return article;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marame-home-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marame-product-rail-controls')) {
    customElements.define('marame-product-rail-controls', class extends HTMLElement {
      connectedCallback() {
        this.track = this.closest('.marame-home-collection')?.querySelector('.marame-home-collection__products');
        if (!this.track) return;
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.hidden = maximum <= 2;
          this.previous.disabled = position <= 2;
          this.next.disabled = position >= maximum - 2;
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-direction]');
          if (!button || button.disabled) return;
          const direction = button.dataset.direction === 'next' ? 1 : -1;
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: direction * rtl * this.track.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.track.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * this.track.clientWidth * .85, behavior });
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : rtl * (this.track.scrollWidth - this.track.clientWidth), behavior });
          }
        }, { signal });
        this.track.addEventListener('scroll', update, { signal, passive: true });
        window.addEventListener('resize', update, { signal, passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(this.track);
        }
        update();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
